import Splide from '@splidejs/splide';

const NEXT_BTNS = document.querySelectorAll('#AppMain .AppMain-next')
const NAV_BTNS = document.querySelectorAll('#app-progress__items .app-progress__item')
const TABS = document.querySelectorAll('#AppMain .splide__slide')
const SOURCE_OTHER = document.querySelectorAll('#AppMain input[name="app_source"]')
const SOURCE_OTHER_VALUE = 'Jinde...'

class AppMain {
  constructor() {
    if(!document.querySelector('#AppMain')){
      return
    }

    this.slider = this.initSplide()
    this.btns = NEXT_BTNS
    this.navs = NAV_BTNS
    this.tabs = TABS
    this.other = SOURCE_OTHER

    this.other.forEach((input) => {
      input.addEventListener('change', () => {
        const checked = document.querySelector('#AppMain input[name="app_source"]:checked')

        if(checked.value == SOURCE_OTHER_VALUE) {
          document.querySelector('#AppMain .app-main__source-other').classList.remove('hide')
          document.querySelector('#AppMain .app-main__source-other input').setAttribute('required', 'required')
        } else {
          document.querySelector('#AppMain .app-main__source-other').classList.add('hide')
          document.querySelector('#AppMain .app-main__source-other input').removeAttribute('required')
        }
      })
    })

    this.btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.moveToNextSlide()
      })
    })

    this.navs.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.slider.go([...btn.parentElement.children].indexOf(btn))
      })
    })

    this.slider.on( 'move', function (newIndex) {
      NAV_BTNS.forEach((navItem) => {
        navItem.classList.remove('current')
      })

      NAV_BTNS[newIndex].classList.add('current')
    } );
  }

  moveToNextSlide = () => {
    if(this.validateActiveSlide()){
      document.body.scrollIntoView({ block: "start" });

      this.slider.go('>')
    }
  }

  validateActiveSlide = () => {
    const activeTab = this.tabs[this.slider.index]
    const requiredFields = activeTab.querySelectorAll(':required')
    const requiredRadioFields = activeTab.querySelectorAll('input[type="radio"]:required')

    let error = false;
    let radioError = false;

    if(!requiredFields.length && !requiredRadioFields.length){
      return true;
    }

    requiredFields.forEach(field => {
      if(!field.value) {
        field.focus()
        field.closest('.app-field').classList.add('is-error')
        field.scrollIntoView()

        error = true;
      }
    });

    if(requiredRadioFields.length){
      radioError = true;

      requiredRadioFields.forEach(field => {
        if(field.checked) {
          radioError = false;
        }
      });
    }

    if(radioError){
      let radio = activeTab.querySelector('.app-field.app-field--radio')
      radio.classList.add('is-error')
      radio.scrollIntoView()
    }

    if(error || radioError) {
      alert('Nejdříve vyplňte všechna povinná pole.')
      return;
    }

    return true;
  }

  initSplide = () => {
    return new Splide( '#AppMain', {
      'arrows': false,
      'pagination': false,
      'drag': false,
      'speed': 600
    } ).mount();
  }
  
}

new AppMain()
